import React from 'react';
import DynamicMultiSelect from "./MultiSelector";
import { Box, Button, Chip, Typography } from "@mui/material";
import DropDown from '../DropDown';

const LocationSelector = ({ 
  division, 
  setDivision, 
  district, 
  setDistrict, 
  locationData, 
  locations, 
  setLocations, 
  locationList, 
  handleToggle, 
  handleReset, 
  handleResetAll, 
  isOpen, 
  openModal, 
  handleClose 
}) => {
  return (
    <div className="grid md:grid-cols-2 w-full h-full md:gap-4 ">
      <div className="w-full">
        <div className="w-full grid lg:grid-cols-2 gap-2 items-center">
          <DropDown
            name={""}
            style={{ width: "100%" }}
            label="Division"
            placeholder={"Select division"}
            value={division}
            onValueChange={(value) => {
              setDivision(value);
            }}
            options={
              locationList && locationList.length
                ? locationList.map((el) => ({
                    name: el.divisionName,
                    value: el.divisionName,
                  }))
                : []
            }
          />
          {division ? (
            <DropDown
              name={""}
              style={{ width: "100%" }}
              label="District"
              placeholder={"Select District"}
              value={district}
              onValueChange={(value) => {
                setDistrict(value);
              }}
              options={[
                { name: "Select District", value: "Select District" },
                ...(locationList
                  .find((el) => el.divisionName === division)
                  ?.district.map((el) => ({
                    name: el.districtName,
                    value: el.districtName,
                  })) || [])
              ]}
            />
          ) : (
            <></>
          )}
        </div>
        <DynamicMultiSelect
          title={"Select Location"}
          data={locationData}
          onChange={setLocations}
          selectedItems={locations}
          clearData={() => {
            setDistrict("");
          }}
          handleToggle={handleToggle}
          isOpen={isOpen}
          openModal={openModal}
          onClose={handleClose}
          handleReset={handleReset}
        />
      </div>

      {/* Selected List */}
      <div className="w-full max-h-56  md:max-h-[40vh] overflow-auto p-3 flex flex-col justify-between shadow-md">
        <Typography variant="h6">{`Selected Locations`}</Typography>
        <Box
          sx={{
            cursor: "pointer",
            py: "5px",
            px: "10px",
            marginTop: "3px",
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: "5px",
            height: "80%",
            overflowY: "auto",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div className="flex flex-wrap gap-3">
            {locations?.length > 0 ? (
              locations?.map((item) => {
                if (!item || !item.length > 0)
                  return (
                    <Chip
                      size="small"
                      key={item.id}
                      label={item.locationName}
                      onDelete={() => handleToggle(item)}
                    />
                  );
                return undefined;
              })
            ) : (
              <p className="text-sm italic">No location has been selected.</p>
            )}
          </div>
        </Box>
        <Button
          onClick={handleResetAll}
          variant="contained"
          sx={{ alignSelf: "flex-end", marginTop: "10px" }}
        >
          Reset All
        </Button>
      </div>
    </div>
  );
};

export default LocationSelector;

